import axios from 'axios'
import store from '../store'
import { filterMenuByName } from '../utils/filterMenu'
import menu from '../store/menu'

class AuthService {
    constructor() {
        this.token = window.localStorage.getItem('token');
        let userData = window.localStorage.getItem('user');
        if (userData !== 'undefined') {
            this.user = userData ? JSON.parse(userData) : null;
            if (this.token !== null) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;
                axios.defaults.headers.common['api-token'] = this.token;
            }
        }
    }

    restoreSession() {
        console.log('=== [AuthService] restoreSession() started ===');

        const token = window.localStorage.getItem('token');
        const userJson = window.localStorage.getItem('user');

        console.log('[restoreSession] Token exists:', !!token);
        console.log('[restoreSession] User data exists:', !!userJson && userJson !== 'undefined');

        if (token && userJson && userJson !== 'undefined') {
            try {
                console.log('[restoreSession] Parsing user from localStorage...');
                const user = JSON.parse(userJson);

                console.log('[restoreSession] User parsed successfully');
                console.log('[restoreSession] User email:', user.email || user.userName);
                console.log('[restoreSession] User role from localStorage:', user.role);
                console.log('[restoreSession] User isSuperAdmin:', user.isSuperAdmin);

                // Restore Vuex state from localStorage user data
                const roleModulePermissions = user.roleModulePermissions || [];
                const roleSubModulePermissions = user.roleSubModulePermissions || [];
                const isSuperAdmin = user.isSuperAdmin || false;

                console.log('[restoreSession] Extracted data:');
                console.log('  - roleModulePermissions count:', roleModulePermissions.length);
                console.log('  - roleSubModulePermissions count:', roleSubModulePermissions.length);
                console.log('  - isSuperAdmin:', isSuperAdmin);
                console.log('  - Role:', user.role);

                console.log('[restoreSession] Dispatching Vuex login action...');
                const vuexPayload = {
                    roles: [user.role],
                    roleModulePermissions,
                    roleSubModulePermissions,
                    isSuperAdmin,
                    user: {
                        userName: user.userName,
                        displayName: user.displayName,
                        role: user.role,
                        isSuperAdmin: isSuperAdmin
                    }
                };
                console.log('[restoreSession] Vuex payload roles:', vuexPayload.roles);
                console.log('[restoreSession] Vuex payload user.role:', vuexPayload.user.role);
                store.dispatch('login', vuexPayload);

                // Verify Vuex state after restore
                console.log('[restoreSession] Verifying Vuex state after restore...');
                console.log('[restoreSession] Vuex store roles:', store.state.roles);
                console.log('[restoreSession] Vuex store currentUser:', store.state.currentUser);
                console.log('[restoreSession] Vuex store isSuperAdmin:', store.state.isSuperAdmin);

                console.log('=== [AuthService] restoreSession() completed successfully ===');
            } catch (error) {
                console.error('=== [AuthService] restoreSession() ERROR ===');
                console.error('[restoreSession] Error parsing or restoring session:', error);
                console.error('[restoreSession] Calling logout to clear corrupted data...');
                // If session data is corrupted, clear it
                this.logout();
            }
        } else {
            console.log('[restoreSession] No valid session data found in localStorage');
            console.log('=== [AuthService] restoreSession() completed - no session to restore ===');
        }
    }

    getUser() {
        api.call('get', apiUrl + 'Account/get-user')
            .then(({ data }) => {
                this.user = data;
            });
    }

    getUserId() {
        return this.user?.id;
    }

    doLogin(data) {
        var url = apiUrl + 'Account/login';
        return api.call('post', url, data)
            .then((response) => {
                console.log(response.data.result);
                return response.data
            });
    }

    register(data) {
        var url = apiUrl + 'Account/Register';
        return api.call('post', url, data)
            .then((response) => {
                return response.data
            });
    }

    recordLogin(token, user) {
        console.log('=== [AuthService] recordLogin() started ===');
        console.log('[recordLogin] User email:', user.email || user.userName);
        console.log('[recordLogin] User role from backend:', user.role);
        console.log('[recordLogin] User isSuperAdmin:', user.isSuperAdmin);

        // Clear cached vuex state to ensure fresh permissions are loaded
        console.log('[recordLogin] Step 1: Removing old vuex from localStorage...');
        window.localStorage.removeItem('vuex');

        console.log('[recordLogin] Step 2: Saving token and user to localStorage...');
        window.localStorage.setItem('token', token);
        window.localStorage.setItem('user', JSON.stringify(user));
        console.log('[recordLogin] localStorage updated - user.role:', user.role);

        console.log('[recordLogin] Step 3: Setting axios headers and AuthService properties...');
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        this.token = token;
        this.user = user;
        console.log('[recordLogin] this.user.role:', this.user.role);

        // Extract permission data
        const roleModulePermissions = user.roleModulePermissions || [];
        const roleSubModulePermissions = user.roleSubModulePermissions || [];
        const isSuperAdmin = user.isSuperAdmin || false;

        console.log('[recordLogin] Step 4: Extracted permissions:');
        console.log('  - roleModulePermissions count:', roleModulePermissions.length);
        console.log('  - roleSubModulePermissions count:', roleSubModulePermissions.length);
        console.log('  - isSuperAdmin:', isSuperAdmin);
        console.log('  - User role:', user.role);

        // Clear old Vuex state to prevent stale data
        console.log('[recordLogin] Step 5: Dispatching Vuex logout to clear old state...');
        store.dispatch('logout');

        // Store the token, user, and permissions in Vuex
        console.log('[recordLogin] Step 6: Dispatching Vuex login with new data...');
        const vuexPayload = {
            roles: [user.role],
            roleModulePermissions,
            roleSubModulePermissions,
            isSuperAdmin,
            user: {
                userName: user.userName,
                displayName: user.displayName,
                role: user.role,
                isSuperAdmin: isSuperAdmin
            }
        };
        console.log('[recordLogin] Vuex login payload roles:', vuexPayload.roles);
        console.log('[recordLogin] Vuex login payload user.role:', vuexPayload.user.role);
        store.dispatch('login', vuexPayload);

        // Verify Vuex state after dispatch
        console.log('[recordLogin] Step 7: Verifying Vuex state after login...');
        console.log('[recordLogin] Vuex store roles:', store.state.roles);
        console.log('[recordLogin] Vuex store currentUser:', store.state.currentUser);
        console.log('[recordLogin] Vuex store isSuperAdmin:', store.state.isSuperAdmin);

        console.log('=== [AuthService] recordLogin() completed ===');
    }

    getPermissions() {
        if (!this.user || !this.user.roleModulePermissions) {
            return {};
        }

        const permissions = {};

        this.user.roleModulePermissions.forEach(permission => {
            const moduleName = permission.module?.name;
            if (moduleName) {
                permissions[moduleName] = {
                    CanAdd: permission.canAdd,
                    CanUpdate: permission.canUpdate,
                    CanDelete: permission.canDelete,
                    CanView: permission.canView
                };
            }
        });

        return permissions;
    }

    /**
     * Check if user has permission for a specific module
     * @param {string} moduleCode - Module code (e.g., 'STOCKS', 'CUSTOMER')
     * @param {string} permissionType - Permission type ('CanView', 'CanAdd', 'CanUpdate', 'CanDelete')
     * @returns {boolean}
     */
    hasModulePermission(moduleCode, permissionType = 'CanView') {
        return store.getters.hasModulePermission(moduleCode, permissionType);
    }

    /**
     * Check if user has permission for a specific submodule
     * @param {string} subModuleCode - Submodule code (e.g., 'STOCK_INFO', 'VEHICLE_INFO')
     * @param {string} permissionType - Permission type ('CanView', 'CanAdd', 'CanUpdate', 'CanDelete')
     * @returns {boolean}
     */
    hasSubModulePermission(subModuleCode, permissionType = 'CanView') {
        return store.getters.hasSubModulePermission(subModuleCode, permissionType);
    }

    /**
     * Get module permission object
     * @param {string} moduleCode - Module code
     * @returns {object|null}
     */
    getModulePermission(moduleCode) {
        return store.getters.getModulePermission(moduleCode);
    }

    /**
     * Get submodule permission object
     * @param {string} subModuleCode - Submodule code
     * @returns {object|null}
     */
    getSubModulePermission(subModuleCode) {
        return store.getters.getSubModulePermission(subModuleCode);
    }

    /**
     * Check if user can access a route
     * @param {string} moduleCode - Module code
     * @param {string} subModuleCode - Optional submodule code
     * @returns {boolean}
     */
    canAccessRoute(moduleCode, subModuleCode = null) {
        return store.getters.canAccessRoute(moduleCode, subModuleCode);
    }

    /**
     * Check if user is Super Admin
     * @returns {boolean}
     */
    isSuperAdmin() {
        return store.getters.isSuperAdmin || this.user?.isSuperAdmin || false;
    }

    /**
     * Get username
     * @returns {string}
     */
    getUserName() {
        return this.user?.userName || store.getters.currentUser?.userName;
    }

    /**
     * Get user role
     * @returns {string}
     */
    getRole() {
        return this.user?.role || store.getters.currentUser?.role;
    }

    /**
     * Get display name
     * @returns {string}
     */
    getDisplayName() {
        return this.user?.displayName || store.getters.currentUser?.displayName;
    }

    /**
     * Logout user
     */
    logout() {
        console.log('=== [AuthService] Logout started ===');
        console.log('Current user before logout:', this.user?.userName || this.user?.email);
        console.log('Current role before logout:', this.user?.role);
        console.log('Token exists:', !!this.token);

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;
        if (this.token) {
            api.call('post', apiUrl + 'Account/logout')
                .then(({ data }) => {
                    console.log('[AuthService] Backend logout successful');
                })
                .catch((error) => {
                    console.error('[AuthService] Backend logout error:', error);
                });
        }

        console.log('[AuthService] Clearing localStorage items...');
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('user');

        console.log('[AuthService] Clearing AuthService instance properties...');
        this.token = null;
        this.user = null;

        console.log('[AuthService] Dispatching Vuex logout action...');
        store.dispatch('logout');

        console.log('=== [AuthService] Logout completed ===');
    }

    /**
     * Check if user is authenticated
     * @returns {boolean}
     */
    check() {
        return !!this.token;
    }

    /**
     * Check if user is authenticated (alias for check)
     * @returns {boolean}
     */
    isAuthenticated() {
        return this.check();
    }
}

export default AuthService;
